/**
 * @packageDocumentation
 * @module      EmcPacketCollection.ts
 * @description Encapsulates the collection of packets obtained for all active systems.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
class EmcPacketCollection {
    static addPacket(emcPacket) {
        var _a;
        let systemId = emcPacket.systemId;
        let packetId = emcPacket.packetId;
        if (false == EmcPacketCollection.emcPackets.has(systemId)) {
            EmcPacketCollection.emcPackets.set(systemId, new Map());
        }
        (_a = EmcPacketCollection.emcPackets.get(systemId)) === null || _a === void 0 ? void 0 : _a.set(packetId, emcPacket);
    }
    static getPacket(systemId, packetId) {
        var _a;
        return (_a = EmcPacketCollection.emcPackets.get(systemId)) === null || _a === void 0 ? void 0 : _a.get(packetId);
    }
    static removePacket(systemId, packetId) {
        var _a;
        (_a = EmcPacketCollection.emcPackets.get(systemId)) === null || _a === void 0 ? void 0 : _a.delete(packetId);
    }
    static removeSystem(systemId) {
        EmcPacketCollection.emcPackets.delete(systemId);
    }
}
EmcPacketCollection.emcPackets = new Map();
export default EmcPacketCollection;
//# sourceMappingURL=EmcPacketCollection.js.map